import React from "react";
import styled from "styled-components/macro";

export const Wrapper = styled.svg`
  aspect-ratio: 38/32;
  height: auto;
  width: auto;
`;

export default () => (
  <Wrapper
    width={38}
    height={32}
    viewBox="0 0 38 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.9943 16.8348C37.9943 11.1751 33.4064 6.5873 27.7467 6.5873C26.8441 6.58729 25.9455 6.70641 25.0742 6.94157C21.3192 7.73915 18.3318 10.5849 16.0103 13.7259C14.5108 15.7548 13.0036 17.615 10.3859 18.1102C7.96724 18.568 4.66547 17.1743 4.4375 14.4404C4.35054 13.3956 4.65635 12.1204 5.24392 11.2444C6.19669 9.82309 7.96535 11.1436 9.22252 11.2846C10.1276 11.3859 11.1191 11.4297 11.9974 11.1433C13.7536 10.5712 14.1155 9.16659 13.1143 7.73354C12.1288 6.3228 10.4686 5.48559 8.74751 5.49141C7.76248 5.49485 6.29507 5.86152 5.57385 6.59354C6.14802 5.39583 5.33459 3.79295 4.86806 3.1267C3.93948 1.80024 1.52884 0.647902 0.359107 2.34833C-0.456502 3.53384 0.277412 5.8597 0.979771 6.9382C1.36741 7.53348 1.92497 8.0937 2.08232 8.80854C2.25413 9.58852 1.87378 10.286 1.60387 10.9969C1.32338 11.7356 1.04169 12.4953 0.915047 13.2747C0.000213683 18.9022 1.55485 23.6719 5.53879 27.1006C6.58602 28.0018 7.78225 28.8046 9.01285 29.4352C10.5139 30.204 12.2385 30.8181 13.8911 31.1613C15.5461 31.5049 17.3354 31.7475 19.0285 31.7475C26.9008 31.7475 33.641 27.8263 36.4361 22.2649C37.4222 20.6902 37.9943 18.8298 37.9943 16.8348Z"
      fill="white"
    />
    <path
      d="M30.5408 4.38664C28.934 3.51794 27.1481 3.45119 25.3981 3.86548C23.638 4.28271 21.7884 5.61078 19.9489 5.46675C18.0766 5.31984 17.8018 3.28492 18.6819 1.97677C20.6125 -0.89129 25.2158 -0.251341 27.6179 1.45386C28.2254 1.88514 28.7853 2.3799 29.288 2.92975C29.6728 3.35028 30.0333 4.11245 30.5408 4.38664Z"
      fill="white"
    />
  </Wrapper>
);
